import React from 'react';
import { TablePagination } from '@mui/material';
import { useTheme as useAppTheme } from '../contexts/ThemeContext';
import { createCommonStyles } from '../theme/styles';

const Pagination = ({
  count,
  page,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25, 50],
  labelRowsPerPage = "Redova po stranici:",
  labelDisplayedRows,
  showFirstButton = true,
  showLastButton = true,
  sx = {}
}) => {
  const { isDarkMode } = useAppTheme();
  const commonStyles = createCommonStyles(isDarkMode);

  const defaultLabelDisplayedRows = ({ from, to, count }) =>
    `${from}-${to} od ${count !== -1 ? count : `više od ${to}`}`;

  const defaultSx = {
    backgroundColor: 'transparent',
    color: commonStyles.textPrimary.color,
    '& .MuiTablePagination-toolbar': {
      color: commonStyles.textPrimary.color,
    },
    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
      color: commonStyles.textPrimary.color,
    },
    '& .MuiSelect-icon': {
      color: commonStyles.textPrimary.color,
    },
    '& .MuiIconButton-root': {
      color: commonStyles.primary?.main || '#3B82F6',
      '&:hover': {
        backgroundColor: `${commonStyles.primary?.main || '#3B82F6'}20`,
      },
      '&.Mui-disabled': {
        color: commonStyles.textSecondary.color,
      }
    }
  };

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      showFirstButton={showFirstButton}
      showLastButton={showLastButton}
      rowsPerPageOptions={rowsPerPageOptions}
      labelRowsPerPage={labelRowsPerPage}
      labelDisplayedRows={labelDisplayedRows || defaultLabelDisplayedRows}
      sx={{ ...defaultSx, ...sx }}
    />
  );
};

export default Pagination;
